import React, { useEffect, useState } from "react";
export default function Loader(props) {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center  pt-4 pb-4">
        <div className="spinner-border" role="status" id="loading">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </>
  );
}
